
<template>
    <div class="container-fluid">
        <Breadcrumb title="Tags" button-url="tagCreate"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <div class="form-group" v-if="isAdmin">
                                <treeselect v-model="userSearch" placeholder="Search by owner"
                                            :options="userSelect"/>
                            </div>
                            <input v-model="tagSearch" type="text" class="form-control form-control-line"
                                   placeholder="Search by tag name">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                                <span>Total:
                                    <span class="label label-info">{{totalItems}}</span>
                                </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="tagList.length > 0">
                                <div class="table-responsive">
                                    <table class="table" id="tagListTable">
                                        <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th v-if="isAdmin">Owner</th>
                                            <th>Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(tag, index) in tagList" :key="index">
                                            <td class="align-middle">{{tag.id}}</td>
                                            <td class="align-middle">{{tag.name}}</td>
                                            <td class="align-middle" v-if="isAdmin">{{tag.user.username}}</td>
                                            <td class="align-middle">
                                                <router-link :to="{ name: 'tagEdit', params: { id: tag.id }}"
                                                             class="btn btn-sm btn-info m-r-10">
                                                    <i class="fa fa-pencil-alt"></i> Edit
                                                </router-link>
                                                <button @click="deleteTag(tag.id)" class="btn btn-sm btn-danger"
                                                        type="button">
                                                    <i class="fa fa-minus-circle"></i> Delete
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <paginate v-if="pageCount > 1"
                                          v-model="page"
                                          :page-count="pageCount"
                                          :page-range="3"
                                          :margin-pages="2"
                                          :click-handler="getItems"
                                          :prev-text="'Prev'"
                                          :next-text="'Next'"
                                          :container-class="'pagination justify-content-center'"
                                          :page-class="'page-item'"
                                          :page-link-class="'page-link'"
                                          :prev-class="'page-item'"
                                          :prev-link-class="'page-link'"
                                          :next-class="'page-item'"
                                          :next-link-class="'page-link'">
                                </paginate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TagService from '../services/TagService';
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import paginateMixin from '../mixins/paginate-mixin';
    import Treeselect from '@riophae/vue-treeselect';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import UserService from '../services/UserService';
    import Swal from 'sweetalert2';

    export default {
        name: 'Tags',
        components: {
            Preloader, Breadcrumb, Treeselect
        },
        mixins: [ paginateMixin ],
        data() {
            return {
                tagSearch: null,
                tagList: [],
                userSearch: null,
                userSelect: [],
                loading: false,
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
                isAdmin: false
            }
        },
        mounted() {
            this.isAdmin = this.$store.getters.isAdmin;
            if (this.isAdmin) {
                UserService.getUserSelect().then(response => {
                    this.userSelect = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                });
            }
            this.getItems(this.page = 1);
        },
        methods: {
            getItems() {
                this.loading = true;
                TagService.getTags(this.page, this.perPage, this.tagSearch, this.userSearch).then(response => {
                    this.tagList = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    this.loading = false;
                });
            },
            search: function () {
                this.getItems(this.page = 1);
            },
            deleteTag(id) {
                Swal({
                    title: 'Are you sure you want to delete?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return TagService.deleteTag(id).then(() => {
                            let tagIndex = this.tagList.findIndex(obj => obj.id === id);
                            this.tagList.splice(tagIndex, 1);
                            this.totalItems--;
                        }).catch(error => {
                            Swal.showValidationMessage(
                                'Error: ' + error.response.data.error[0]
                            )
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Deleted successfully!',
                            `Tag has been deleted.`,
                            'success'
                        )
                    }
                })
            }
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            }
        }
    }
</script>

<style scoped>

</style>